/* jscs:disable maximumLineLength */
export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://t.me/share/url',
                params: {
                    url: 'url',
                    text: 'title'
                }
            }
        }
    },

    i18n: {
        az: 'Telegram',
        be: 'Telegram',
        en: 'Telegram',
        hy: 'Telegram',
        ka: 'Telegram',
        kk: 'Telegram',
        ro: 'Telegram',
        ru: 'Telegram',
        tr: 'Telegram',
        tt: 'Telegram',
        uk: 'Telegram',
        uz: 'Telegram'
    },

    color: '#64a9dc'
};
